import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { useLanguage } from "../i18n/LanguageProvider";

export default function FaqAccordion() {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);
  const faqItems = t("faq.items", []);

  return (
    <div style={styles.wrap}>
      <div style={styles.intro}>
        <img
          src="/vaultquest-logo.png"
          alt=""
          aria-hidden="true"
          style={styles.logo}
        />
        <h1 style={styles.title}>{t("faq.title")}</h1>
        <p style={styles.subtitle}>{t("faq.subtitle")}</p>
      </div>

      <div style={styles.list}>
        {Array.isArray(faqItems) &&
          faqItems.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={item.question}
                style={{
                  ...styles.item,
                  ...(isOpen ? styles.itemOpen : {}),
                }}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  style={styles.questionButton}
                >
                  <span style={styles.questionNumber}>
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span style={styles.question}>{item.question}</span>
                  <FiChevronDown
                    aria-hidden="true"
                    style={{
                      ...styles.chevron,
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </button>

                <div
                  style={{
                    ...styles.answerShell,
                    gridTemplateRows: isOpen ? "1fr" : "0fr",
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <div style={styles.answerInner}>
                    <p style={styles.answer}>{item.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto",
    color: "white",
    fontFamily: "'Cooper Hewitt', system-ui, -apple-system, Arial, sans-serif",
  },
  intro: {
    position: "relative",
    textAlign: "center",
    marginBottom: "26px",
    padding: "18px 10px 6px",
  },
  logo: {
    width: "78px",
    height: "78px",
    display: "block",
    margin: "0 auto 12px",
    filter: "drop-shadow(0 14px 28px rgba(255,0,170,0.28))",
  },
  title: {
    margin: 0,
    fontSize: "clamp(38px, 10vw, 64px)",
    lineHeight: 1.05,
    fontWeight: 1000,
    letterSpacing: "0",
    textTransform: "none",
    fontFamily: "'Cooper Hewitt', 'Arial Black', system-ui, -apple-system, Arial, sans-serif",
    background: "linear-gradient(90deg, #ffffff 0%, #ff2bd6 48%, #9b5cff 100%)",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    color: "transparent",
    textShadow: "0 18px 42px rgba(255,0,170,0.18)",
  },
  subtitle: {
    maxWidth: "620px",
    margin: "12px auto 0",
    color: "rgba(255,255,255,0.70)",
    fontSize: "14px",
    lineHeight: 1.6,
  },
  list: {
    display: "grid",
    gap: "12px",
  },
  item: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "18px",
    background:
      "linear-gradient(135deg, rgba(255,255,255,0.075), rgba(124,58,237,0.055))",
    border: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "0 14px 36px rgba(0,0,0,0.20), inset 0 1px 0 rgba(255,255,255,0.10)",
    transition: "border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease",
  },
  itemOpen: {
    borderColor: "rgba(255,0,170,0.40)",
    boxShadow: "0 18px 48px rgba(0,0,0,0.26), 0 0 28px rgba(255,0,170,0.12), inset 0 1px 0 rgba(255,255,255,0.14)",
  },
  questionButton: {
    width: "100%",
    minHeight: "66px",
    display: "grid",
    gridTemplateColumns: "42px minmax(0, 1fr) auto",
    alignItems: "center",
    gap: "12px",
    padding: "16px 18px",
    background: "transparent",
    border: "none",
    color: "white",
    textAlign: "left",
    cursor: "pointer",
  },
  questionNumber: {
    width: "34px",
    height: "34px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(255,0,170,0.45), rgba(124,58,237,0.36))",
    color: "#ffffff",
    fontSize: "12px",
    fontWeight: 1000,
    letterSpacing: "0.6px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.18)",
  },
  question: {
    fontSize: "15px",
    lineHeight: 1.35,
    fontWeight: 900,
    letterSpacing: "0.2px",
    textTransform: "uppercase",
  },
  chevron: {
    flex: "0 0 auto",
    color: "rgba(255,255,255,0.7)",
    fontSize: "24px",
    transition: "transform 180ms ease",
  },
  answerShell: {
    display: "grid",
    overflow: "hidden",
    transition: "grid-template-rows 220ms ease, opacity 180ms ease",
  },
  answerInner: {
    minHeight: 0,
    padding: "0 18px 0 min(72px, 17vw)",
  },
  answer: {
    margin: "0 0 20px",
    color: "rgba(255,255,255,0.78)",
    fontSize: "15px",
    lineHeight: 1.65,
  },
};
